import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

export const PrivacyPage = () => {
  const { t } = useTranslation();

  return (
    <div 
      className="min-h-screen py-20"
      style={{ backgroundColor: 'var(--th-background)' }}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 mb-8 font-medium transition-colors"
          style={{ color: 'var(--th-secondary)' }}
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-5 h-5" />
          Back to Home
        </Link>

        <motion.div
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
        >
          <h1 
            className="font-heading text-4xl md:text-5xl font-bold mb-4"
            style={{ color: 'var(--th-text-primary)' }}
          >
            {t('privacy.title')}
          </h1>
          <p 
            className="text-sm mb-8"
            style={{ color: 'var(--th-text-muted)' }}
          >
            {t('privacy.lastUpdated')}
          </p>

          <div 
            className="prose prose-lg max-w-none"
            style={{ color: 'var(--th-text-secondary)' }}
          >
            <p className="text-lg mb-8">{t('privacy.intro')}</p>

            {[1, 2, 3, 4, 5, 6, 7].map((num) => (
              <section key={num} className="mb-8">
                <h2 
                  className="font-heading text-2xl font-bold mb-4"
                  style={{ color: 'var(--th-text-primary)' }}
                >
                  {t(`privacy.section${num}Title`)}
                </h2>
                <p>{t(`privacy.section${num}Content`)}</p>
              </section>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export const TermsPage = () => {
  const { t } = useTranslation();

  return (
    <div 
      className="min-h-screen py-20"
      style={{ backgroundColor: 'var(--th-background)' }}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 mb-8 font-medium transition-colors"
          style={{ color: 'var(--th-secondary)' }}
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-5 h-5" />
          Back to Home
        </Link>

        <motion.div
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
        >
          <h1 
            className="font-heading text-4xl md:text-5xl font-bold mb-4"
            style={{ color: 'var(--th-text-primary)' }}
          >
            {t('terms.title')}
          </h1>
          <p 
            className="text-sm mb-8"
            style={{ color: 'var(--th-text-muted)' }}
          >
            {t('terms.lastUpdated')}
          </p>

          <div 
            className="prose prose-lg max-w-none"
            style={{ color: 'var(--th-text-secondary)' }}
          >
            <p className="text-lg mb-8">{t('terms.intro')}</p>

            {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => (
              <section key={num} className="mb-8">
                <h2 
                  className="font-heading text-2xl font-bold mb-4"
                  style={{ color: 'var(--th-text-primary)' }}
                >
                  {t(`terms.section${num}Title`)}
                </h2>
                <p>{t(`terms.section${num}Content`)}</p>
              </section>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};
